export const invoiceFeatures = {
    scheduleSendInvoice: false,
    canSelectCountries: false,
    canSearchKBO: false,
}